//info publica

import React, { useState, useEffect } from 'react'
import { getInformacionPublica } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const InformacionPublica = () => {
    const [allData, setAllData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getInformacionPublica();
            setAllData(res);
        };
        fetchData();
    }, []);
    console.log("DATAAAA", allData);

    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">Información Pública</h1>
                {allData.map((item, index) => {
                    console.log("ITEM", item);
                    return (
                        <Col key={index} className='mb-4'>
                            <h2>Ley Nº 9070 de Acceso a la Información Pública:</h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf.ley_de_acceso_a_la_informacion_publica,
                                }}
                            />
                            <hr></hr>

                            <h2>Información Institucional Organizativa y de Gestión</h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf?.informacion_institucional,
                                }}
                            />
                            <hr></hr>

                            <h2>INFORMACIÓN DE RELEVANCIA JURÍDICA</h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf?.informacion_de_relevancia_juridica,
                                }}
                            />

                        </Col>
                    )
                })}

            </Row>
        </Container>
    );
};
export default InformacionPublica